import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '../Pages/HomePage';
import { AuthGuard } from './AuthGuard';
import { dashboardRoutes } from '../Components/Navigation/dashboardRoutes';
import { BASE_PATH } from '../Constants/constants';
import LoginPage from '../Pages/LoginPage';

export function Router(): React.ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<AuthGuard />}>
        <Route path={`/${BASE_PATH}/:userId/`} element={<HomePage />}>
          {/* go through the routes and generate them */}
          {dashboardRoutes.map((route) => (
            <Route
              key={route.key}
              path={route.path}
              element={route.component}
            />
          ))}
        </Route>
      </Route>
    </Routes>
  );
}

export default Router;
